import axios from 'axios';
import { refreshToken, logout, getAccessToken } from '../authService';
import enhanceError from './enhanceError';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API,
  timeout: 60000,
});

instance.interceptors.request.use(
  (config) => ({
    ...config,
    data: typeof config.data === 'object'
      ? Object.fromEntries(Object.entries(config.data).filter((e) => e[1] !== ''))
      : config.data,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${getAccessToken()}`,
    },
  }),
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => Promise.resolve({ ...response, rejectException: () => enhanceError(response) }),
  async (error) => {
    if (error.response?.status === 401) {
      try {
        await refreshToken();
        return axios.request(error.config);
      } catch (e) {
        await logout();
        window.location = '/';
      }
    }

    return (error.response !== undefined)
      ? Promise.resolve({ ...error.response, rejectException: () => enhanceError(error.response) })
      : Promise.reject(error);
  },
);

export default instance;
